module.exports = __webpack_public_path__ + "img/three2Red.4c62493e.jpg";